
export const experienceMapping = {
  'strand': [
    'strand', 'beach', 'zee', 'zeezicht', 'kust', 'kustzicht', 'zeegebied', 
    'aan zee', 'buitenzwembad', 'zwembad', 'zandstrand', 'zeevakantie',
    'strandvakantie', 'coastal', 'waterfront', 'seaside', 'oceanview'
  ],
  'zee': [
    'zee', 'strand', 'beach', 'zeezicht', 'kust', 'kustzicht', 'zeegebied',
    'aan zee', 'zandstrand', 'zeevakantie', 'strandvakantie', 'ocean', 'sea'
  ],
  'kust': [
    'kust', 'kustzicht', 'strand', 'beach', 'zee', 'zeezicht', 'coastal',
    'aan de kust', 'kustlijn', 'zeegebied', 'seaside'
  ],
  'meer': [
    'meer', 'lake', 'meerzicht', 'aan het meer', 'lakeside', 'lake view',
    'binnenmeer', 'bergmeer', 'meergebied'
  ],
  'wellness': [
    'wellness', 'spa', 'ontspanning', 'massage', 'sauna', 'beauty', 
    'relaxation', 'thermal', 'wellnesscentrum'
  ],
  'sport': [
    'sport', 'actief', 'fitness', 'golf', 'tennis', 'zwemmen', 'duiken',
    'wandelen', 'fietsen', 'watersport', 'skiing', 'snowboard'
  ],
  'cultuur': [
    'cultuur', 'cultuur', 'museum', 'geschiedenis', 'monumenten', 'art',
    'historic', 'cultural', 'heritage', 'sightseeing'
  ],
  'natuur': [
    'natuur', 'nature', 'bos', 'park', 'bergen', 'rivier', 
    'landschap', 'wildlife', 'hiking', 'mountains'
  ],
  'romantic': [
    'romantisch', 'romantic', 'honeymoon', 'couples', 'huwelijksreis',
    'valentine', 'anniversary', 'intimate'
  ],
  'family': [
    'familie', 'family', 'kinderen', 'kids', 'gezin', 'child friendly',
    'kindvriendelijk', 'playground', 'entertainment'
  ]
};

export const detectExperienceType = (searchTerms: string[]): string | null => {
  for (const [type, keywords] of Object.entries(experienceMapping)) {
    if (keywords.some(keyword => 
      searchTerms.some(term => 
        term.toLowerCase().includes(keyword.toLowerCase()) || 
        keyword.toLowerCase().includes(term.toLowerCase())
      )
    )) {
      console.log('Detected experience type:', type, 'from keywords:', keywords.filter(k => 
        searchTerms.some(term => 
          term.toLowerCase().includes(k.toLowerCase()) || 
          k.toLowerCase().includes(term.toLowerCase())
        )
      ));
      return type;
    }
  }
  return null;
};
